// generated from 4_260 samples

import { z } from "zod";
import { filterGetBaseSchema } from "./filterGetBaseSchema";

export const xPurchasesInYDaysGetSchema = z.object({
  ...filterGetBaseSchema.shape,
  filter_key: z.literal("x_purchases_in_y_days"),
  comparison_key: z.enum([
    "1", // 2_426 (56.95%)
    "3", // 1_161 (27.25%)
    "5", // 673 (15.80%)
  ]),
  display_name: z.string(),
  // undefined: 624 (14.65%), defined 3_636 (85.35%)
  raw_value: z
    .object({
      num_days: z.int().min(1).max(30),
      num_occurrences: z.int().min(0),
    })
    .optional(),
  value: z.object({
    num_days: z.int().min(1).max(30),
    num_occurrences: z.int().min(0),
  }),
  varies_by_app_group: z.literal(false),
});
